module.exports = __webpack_public_path__ + "img/15.2dec9960.jpg";